module.exports = { apiUrl: 'https://api-app.loadmanager.io/api/v1' }
